import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Exclusão de documento ainda não assinado.
export function useDeleteDocument() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((patientId, documentId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/patients/${patientId}/documents/${documentId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
